function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6544",
    transform: "translate(-1528 -6448)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(1528 6448)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "icons8-instagram (2)",
    d: "M10.881 5A5.9 5.9 0 0 0 5 10.881v8.239A5.9 5.9 0 0 0 10.881 25h8.239A5.9 5.9 0 0 0 25 19.119v-8.238A5.9 5.9 0 0 0 19.119 5zm0 1.818h8.239a4.057 4.057 0 0 1 4.063 4.063v8.239a4.057 4.057 0 0 1-4.062 4.063h-8.24a4.057 4.057 0 0 1-4.063-4.062v-8.24a4.057 4.057 0 0 1 4.063-4.063zm9.489 1.989a.824.824 0 1 0 .824.824.82.82 0 0 0-.825-.824zM15 9.545A5.455 5.455 0 1 0 20.455 15 5.47 5.47 0 0 0 15 9.545zm0 1.818A3.636 3.636 0 1 1 11.364 15 3.621 3.621 0 0 1 15 11.364z",
    transform: "translate(1533 6453)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.edf5cdce40d7d9b115dbfd182ae34985.svg";
export { ForwardRef as ReactComponent };